<template>
  <div class="image-table">
    <div class="head">
      <div class="bts">
        <el-input v-model="params.total" :disabled='true' type="primary" style="margin:0 5px;width: 70px;" placeholder="TopK" />
        <el-upload
          ref="imageUploader"
          :on-change="handleFileChange"
          :before-upload="handleUploadBefore"
          :on-success="handleSuccess"
          :on-error="removeField"
          drag
          :auto-upload="true"
          :action="upload()"
          :data="params"
          class="avatar-uploader"
          :limit="0"
          list-type="picture"
          accept="image/jpeg, image/jpg, image/png, image/bmp"
          :show-file-list="false"
          :file-list="fileList"
        >
          <el-input
            style="margin-right: 5px;"
            placeholder="请上传图片或拖入图片"
          >
            <i slot="prefix" class="el-icon-search el-input__icon" />
          </el-input>
        </el-upload>
        <div class="img-upload">
          <el-image
            v-if="imgUrl"
            :src="imgUrl"
            :preview-src-list="[imgUrl]"
            fit="contain"
            lazy
            class="el-image"
          />
          <div v-else style=" width:0px;border: none" />
        </div>
      </div>
    </div>
    <template v-if="params.total !== 0 ">
        <div class="cards" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="500">
            <image-card
              v-for="(data, index) in tableData"
              :key="index"
              :data="data"
            />
        </div>
    </template>
    <empty-data
      v-else-if="!imgFile || !imgFile.size"
      title="您还未上传图片，请拖入图片或点击上传"
    />
    <empty-data v-else title="图像搜索" />
  </div>
</template>

<script>
import EmptyData from '@/components/empty-data/EmptyData'
import tableMixin from '@/common/mixin/table-mixin'
import ImageCard from '@/components/image-card'

export default {
  name: 'CommonImageTable',
  components: { ImageCard, EmptyData },
  mixins: [tableMixin],
  data() {
    return {
      params: {
        topK: 20,
        total: 0
      },
      handleSuccessStatus: false,
      busy: false,
      scrollY:0,
      bodyStyle:'',
      imgFile: '',
      tableData: [],
      fileList: [],
      page: {
        pageSize: 20
      }
    }
  },
  created() {
    this.stopBodyScroll(true)
    this.tableData = this.$route.params.searchData.tableData
    this.params.topK = Number(this.params.topK) + this.page.pageSize
    this.params.total = this.$route.params.searchData.total
    this.handleSuccessStatus = false
    this.imgFile = this.$route.params.searchData.image
    this.fileList.push(this.$route.params.searchData.image)
    this.fileList[0].status = 'ready'
  },
  computed: {
    emptyParam() {
      return !this.imgFile && (!this.params.topK || !this.params.topK.length)
    },
    imgUrl() {
      return this.imgFile ? this.imgFile.url : ''
    }
  },
  mounted() {
    document.addEventListener('paste', this.handlectrlvEvent),
    this.setEmptyTable()
  },
  beforeDestroy () {
    document.removeEventListener('paste', this.handlectrlvEvent)
  },
  methods: {
    upload() {
      // return 'http://127.0.0.1:9000/api/search/simpleSearch'
      return 'https://www.datuji.com/api/search/simpleSearch'
    },
    doMoreQuery() {
      console.log('doMoreQuery')
      this.$refs.imageUploader.submit()
    },
    handleSuccess(response, file, fileList) {
      console.log('handleSuccess')
      if (response.success && response.data) {
        if (response.total > 0) {
          const data = response.data
          data.forEach(a => {
            a.score = ((1 / (1 + Number(a.score))) * 100).toFixed(0)
            // a.score = (Number(a.score)).toFixed(2)
          })
          const sortedData = data.sort((a, b) => {
            return b.score - a.score
          })
          // 更新页面图片数量：总数
          this.params.topK = Number(this.params.topK) + Number(this.page.pageSize)
          this.params.total = Number(this.params.total) + Number(response.total)
          if(this.tableData.length === 0){
            this.tableData = sortedData
          }else{
            this.tableData = this.tableData.concat(sortedData)
          }
        }
      }
      this.handleSuccessStatus = true
      this.imgFile = file
      this.busy = false
    },
    handleFileChange(file, fileList) {
      console.log('handleFileChange')
      console.log(fileList)
      if (fileList[0] && fileList[0].size > 2097152) {
        this.$message.warning('请上传小于2M大小的图片')
        this.$refs.imageUploader.clearFiles()
        return false
      }
      // 清空数据，因为数据是追加方式显示，换图片清空已有数据
      if(!this.handleSuccessStatus){
        console.log('clearFiles')
        this.params.topK = 20
        this.params.total = 0
        this.tableData = []
        this.imgFile = file
        this.$refs.imageUploader.clearFiles()
        this.fileList = []
        this.fileList.push(file)
      }else{
        this.handleSuccessStatus = false
      }
      this.fileList[0].status = 'ready'
    },
    handleUploadBefore(file) {
      // if (file.size > 2097152) {
      //   this.$message.warning('请上传小于2M大小的图片')
      //   return false
      // }
    },
    removeField() {
      this.$refs.imageUploader.clearFiles()
    },
    handlectrlvEvent(event) {
      console.log('handlectrlvEvent')
      const items = (event.clipboardData || window.clipboardData).items;
      //去除粘贴到div事件
      event.preventDefault();
      event.returnValue=false;
      let file = null;
      if (!items || items.length === 0) {
        this.$message.error("当前不支持本地图片上传");
        return;
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        console.log(items[i].type)
        if (items[i].type.includes('image')) {
          file = items[i].getAsFile();
          break;
        }
      }
      if (!file) {
        console.log('粘贴内容非图片')
        this.$message.error("粘贴内容非图片");
        return;
      } else {
        this.params.topK = 20
        this.params.total = 0
        this.tableData = []
        this.$refs.imageUploader.clearFiles()
        this.fileList = []
        this.$refs.imageUploader.handleStart(file);
        let that = this
        setTimeout(() => {
          that.doMoreQuery()
        }, 1000)
      }
    },
    stopBodyScroll(isFixed) {
      if (isFixed) {
        this.scrollY = window.scrollY
        this.bodyStyle = document.body.style;
        document.body.style = `position:fixed;top:-${this.scrollY}px;height: 100%;width:100%;overflow: hidden;`
      } else {
        document.body.style = this.bodyStyle
        window.scrollTo(0, this.scrollY)
      }
    },
    loadMore() {
      this.busy = true
      let that = this
      setTimeout(() => {
        that.doMoreQuery()
      }, 1000)
    }
  }
}
</script>

<style lang='scss' scoped>
  @import "~@/assets/styles/base";
.el-image {
  display: inline-block;
  text-align: center;
  color: #fff;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  vertical-align: middle;
  width: 40px;
  height: 40px;
  line-height: 40px;
  :global(.el-image__error) {
    display: none;
  }
}

.image-table {
  position: relative;
  top: 20px;
  box-sizing: border-box;
  height: calc(80vh - 10px);

  :global(.el-upload-dragger) {
    border: none;
    border-radius: 0;
    box-sizing: border-box;
    width: 450px;
    height: 40px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  :global(.el-radio-button__inner) {
    color: rgba(14, 37, 60, 1);
    font-weight: 400;

    .iconfont {
      color: rgba(14, 37, 60, 1);
      font-weight: 400;
    }
  }

  :global(.el-upload) {
    border: none;
    display: inherit;
  }
}

.img-upload {
  @include all-height(36px);
  @include flex-row-between-center;
  width: 36px;
  margin: 0 0 0 8px;
  img {
    width: 36px;
    height: 36px;
  }
}

.head {
  margin: 10px 0;
  .bts {
    @include flex-row-all-center;
  }
}

.cards {
  @include flex-row;
  display:flex;
  justify-content:center;
  align-items:center;
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  flex-wrap: wrap;
}

</style>



// WEBPACK FOOTER //
// src/components/image-table.vue